<div [formGroup]="form" class="flex flex-col gap-4">
  <!-- Header -->
  <div class="flex items-center justify-between">
    <h2 class="typo-h3-semibold text-text-secondary">{{ 'health_history_patient_info_modal_title' | translate }}</h2>
    <button type="button" class="cursor-pointer" (click)="onCancel()">
      <svg-icon class="h-4 w-4 text-text-primary" key="px-16-x"></svg-icon>
    </button>
  </div>

  <!-- Profile -->
  <div class="flex h-[500px] flex-col gap-4 overflow-y-auto rounded-2xl bg-background-card p-4">
    <div class="flex gap-3">
      <div class="flex w-full flex-col gap-1">
        <span class="typo-h5-book ml-2 leading-none text-text-primary">{{ 'health_history_patient_info_modal_first_name' | translate }}</span>
        <span class="typo-h4-medium ml-2 pt-[15px] leading-none text-text-primary">{{ data.patient.firstName }}</span>
      </div>
      <div class="flex w-full flex-col gap-1">
        <span class="typo-h5-book ml-2 leading-none text-text-primary">{{ 'health_history_patient_info_modal_last_name' | translate }}</span>
        <span class="typo-h4-medium ml-2 pt-[15px] leading-none text-text-primary">{{ data.patient.lastName }}</span>
      </div>
    </div>
    <div class="flex gap-3">
      <div class="flex w-full flex-col gap-1">
        <span class="typo-h5-book ml-2 leading-none text-text-primary">{{ 'health_history_patient_info_modal_date_of_birth' | translate }}</span>
        <span class="typo-h4-medium ml-2 pt-[15px] leading-none text-text-primary">{{ data.patient.birthDate ?? '' | date: 'MM/dd/yyyy' }}</span>
      </div>
      <div class="flex w-full flex-col gap-1">
        <span class="typo-h5-book ml-2 leading-none text-text-primary">{{ 'health_history_patient_info_modal_age' | translate }}</span>
        <span class="typo-h4-medium ml-2 pt-[15px] leading-none text-text-primary">{{ data.patient.birthDate ?? '' | age }}</span>
      </div>
    </div>
    <div class="flex gap-3">
      <div class="flex w-full flex-col gap-1">
        <span class="typo-h5-book ml-2 leading-none text-text-primary">{{ 'health_history_patient_info_modal_mobile' | translate }}</span>
        <span class="typo-h4-medium ml-2 pt-[15px] leading-none text-text-primary">{{ data.patient.mobilePhone ?? '-' }}</span>
      </div>
      <div class="flex w-full flex-col gap-1">
        <span class="typo-h5-book ml-2 leading-none text-text-primary">{{ 'health_history_patient_info_modal_home' | translate }}</span>
        <span class="typo-h4-medium ml-2 pt-[15px] leading-none text-text-primary">{{ data.patient.homePhone ?? '-' }}</span>
      </div>
    </div>

    @if (hasEmergency) {
      <!-- Emergency contact -->
      <div class="flex flex-col gap-2">
        <h3 class="ml-2 text-h8 font-medium leading-none text-primary-blue">
          {{ 'health_history_patient_secondary_emergency_contact' | translate }}
        </h3>
        <lib-input
          type="text"
          formControlName="emergencyName"
          [placeholder]="'health_history_patient_secondary_contact_name' | translate"
          [state]="form.controls.emergencyName.errors?.['nameRequired'] || form.controls.emergencyName.errors?.['nameTooLong'] ? 'error' : 'normal'"
        ></lib-input>
        <lib-input
          type="text"
          formControlName="emergencyPhone"
          libAppPhoneMask
          [placeholder]="'health_history_patient_secondary_contact_phone' | translate"
          [state]="form.controls.emergencyPhone.errors?.['phoneRequired'] ? 'error' : 'normal'"
        ></lib-input>
        <!-- TODO: Will be added back later when API is ready -->
        <!-- <lib-input
          type="text"
          formControlName="emergencyRelationship"
          [placeholder]="'health_history_patient_info_modal_relationship_placeholder' | translate"
        ></lib-input> -->
      </div>
    }

    @if (hasPharmacy) {
      <!-- Pharmacy -->
      <div class="flex flex-col gap-2">
        <h3 class="ml-2 text-h8 font-medium leading-none text-primary-blue">
          {{ 'health_history_patient_secondary_pharmacy' | translate }}
        </h3>
        <lib-input
          type="text"
          formControlName="pharmacyName"
          [placeholder]="'health_history_patient_secondary_contact_name' | translate"
          [state]="form.controls.pharmacyName.errors?.['nameRequired'] || form.controls.pharmacyName.errors?.['nameTooLong'] ? 'error' : 'normal'"
        ></lib-input>
        <lib-input
          type="text"
          formControlName="pharmacyPhone"
          libAppPhoneMask
          [placeholder]="'health_history_patient_secondary_contact_phone' | translate"
          [state]="form.controls.pharmacyPhone.errors?.['phoneRequired'] ? 'error' : 'normal'"
        ></lib-input>
        <!-- TODO: Will be added back later when API is ready -->
        <!-- <lib-input
          type="text"
          formControlName="pharmacyFax"
          [placeholder]="'health_history_patient_info_modal_fax_placeholder' | translate"
        ></lib-input>
        <lib-input
          type="text"
          formControlName="pharmacyAddress"
          [placeholder]="'health_history_patient_info_modal_address_placeholder' | translate"
        ></lib-input> -->
      </div>
    }

    @if (hasPhysician) {
      <!-- Physician contact -->
      <div class="flex flex-col gap-2">
        <h3 class="ml-2 text-h8 font-medium leading-none text-primary-blue">
          {{ 'health_history_patient_secondary_physician' | translate }}
        </h3>
        <lib-input
          type="text"
          formControlName="physicianName"
          [placeholder]="'health_history_patient_secondary_contact_name' | translate"
          [state]="form.controls.physicianName.errors?.['nameRequired'] || form.controls.physicianName.errors?.['nameTooLong'] ? 'error' : 'normal'"
        ></lib-input>
        <lib-input
          type="text"
          formControlName="physicianPhone"
          libAppPhoneMask
          [placeholder]="'health_history_patient_secondary_contact_phone' | translate"
          [state]="form.controls.physicianPhone.errors?.['phoneRequired'] ? 'error' : 'normal'"
        ></lib-input>
        <!-- TODO: Will be added back later when API is ready -->
        <!-- <lib-input
          type="text"
          formControlName="physicianSpeciality"
          [placeholder]="'health_history_patient_info_modal_speciality_placeholder' | translate"
        ></lib-input> -->
      </div>
    }
  </div>

  <!-- Buttons -->
  <div class="flex justify-end gap-2">
    <button type="button" class="btn-secondary px-5" (click)="onCancel()">
      {{ 'health_history_patient_info_modal_cancel' | translate }}
    </button>
    <button type="button" class="btn-primary px-5" (click)="onSave()" [disabled]="form.invalid">
      <svg-icon key="px-24-save" size="md"></svg-icon>
      {{ 'health_history_patient_info_modal_save' | translate }}
    </button>
  </div>
</div>
